import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(root)/error.tsx");
